import classNames from "classnames";
import styles from "./Elements.module.css";

// eslint-disable-next-line import/prefer-default-export
export function makeTemplateComponent(TagName, ...supClass) {
  const component = ({
    className,
    children,
    ...rest
  }: {
    className?: string;
    children: any;
  }) => (
    <TagName {...rest} className={classNames(className, supClass)}>
      {children}
    </TagName>
  );
  component.displayName = TagName;
  return component;
}

export const MainContainer = makeTemplateComponent(
  "div",
  classNames("container-fluid p-0 m-0", styles.mainContainer),
);

export const AdminContainer = makeTemplateComponent(
  "div",
  classNames(styles.adminContainer, "containvh-100 vw-100"),
);

export const AdminContent = makeTemplateComponent(
  "main",
  classNames(styles.adminContent, "rounded-5"),
);

export const PageContainer = makeTemplateComponent("div", "");

export const PageContent = makeTemplateComponent(
  "main",
  classNames("container col-12"),
);
export const PageContentFluid = makeTemplateComponent(
  "main",
  classNames("container-fluid col-12 m-0 p-0"),
);
export const MainContent = makeTemplateComponent(
  "div",
  "container-fluid position-relative",
);

export const Row = makeTemplateComponent("div", styles.row);

export const ActionBar = makeTemplateComponent("div", styles.actionBar);

export const ScrollWrapper = makeTemplateComponent("div", "");
